import React from "react";
import {
  SmileOutlined,
  UserSwitchOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";

export const parentLabel = {
  smartBeans: "智慧豆管理",
  moduleRoleManager: "模块角色管理",
  userManager: "成员管理",
  studentInfoManage: "学员信息管理",
};

export const getLableByPath = (path) => {
  if (
    path === routerPath.smartBeansSearch ||
    path === routerPath.smartBeansInput
  ) {
    return "smartBeans" + path;
  }

  if (path === "/ModuleRoleAdd") {
    return "moduleRoleManager" + "/moduleRoleAdd";
  }

  if (path === "/UserAdd") {
    return "userManager" + "/userAdd";
  }

  if (path === "/departAdd") {
    return "moduleRoleManager" + "/departAdd";
  }
};

export const childrenLabel = {
  smartBeansSearch: "智慧豆查询",
  smartBeansInput: "智慧豆录入",
  inpurtStatusSearch: "录入状态查询",
  smartBeansAudit: "智慧豆审核",
  moduleRole: "模块角色",
  moduleRoleAdd: "新增模块角色",
  userSearch: "成员查询",
  userAdd: "新增成员",
  departAdd: "添加版块或新手村",
  studentInfoAdd: "学员录入",
  studentInfoSearch: "学员信息查询",
};

const icons = [
  SmileOutlined,
  UserSwitchOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
];

export const routerPath = {
  login: "/login",
  smartBeansSearch: "/smartBeansSearch",
  smartBeansInput: "/smartBeansInput",
  inpurtStatusSearch: "/inpurtStatusSearch",
  smartBeansAudit: "/smartBeansAudit",
  moduleRole: "/moduleRole",
  moduleRoleAdd: "/moduleRoleAdd",
  userSearch: "/userSearch",
  userAdd: "/userAdd",
  departAdd: "/departAdd",
  studentInfoAdd: "/studentInfoAdd",
  studentInfoSearch: "/studentInfoSearch",
};

export const permissionIdObj = {
  userManager: "1001", // 成员管理
  userSearch: "1001001", // 成员查询
  userAdd: "1001002", // 新增成员
  moduleRoleManager: "1003", // 模块角色管理
  moduleRole: "1003001", // 模块角色
  moduleRoleAdd: "1003002", // 新增模块角色
  smartBeans: "1002", // 智慧豆管理
  smartBeansInput: "1002001", // 智慧豆录入
  smartBeansAudit: "1002002", // 智慧豆审核
  studentInfo: "1004", // 基础信息
  studentInfoAdd: "1004001", // 基础信息添加
};

export const getSelectedKeyByPath = (path) => {
  if (!path) return null;
  console.log("path_+_", path);
  path = path.replace("/", "");

  for (let idx = 0; idx < routerConfig.length; idx++) {
    const item = routerConfig[idx];

    if (item && item.children && item.children.length > 0) {
      const children = item.children;
      for (let i = 0; i < children.length; i++) {
        const ele = children[i];
        if (ele.key.toLocaleLowerCase() === path.toLocaleLowerCase()) {
          return ele.key;
        }
      }
    }
  }
};

export const routerConfig = [
  {
    key: "smartBeans",
    permissionId: permissionIdObj.smartBeans,
    icon: React.createElement(icons[0]),
    label: parentLabel.smartBeans,
    children: [
      {
        key: "smartBeansSearch",
        label: childrenLabel.smartBeansSearch,
        permissionId: permissionIdObj.smartBeans,
      },
      {
        key: "smartBeansInput",
        label: childrenLabel.smartBeansInput,
        permissionId: permissionIdObj.smartBeansInput,
      },
      // {
      //   key: "inpurtStatusSearch",
      //   label: childrenLabel.inpurtStatusSearch,
      // },
      {
        key: "smartBeansAudit",
        label: childrenLabel.smartBeansAudit,
        permissionId: permissionIdObj.smartBeansAudit,
      },
    ],
  },
  {
    key: "moduleRoleManager",
    permissionId: permissionIdObj.moduleRoleManager,
    icon: React.createElement(icons[1]),
    label: parentLabel.moduleRoleManager,
    children: [
      {
        key: "moduleRole",
        label: childrenLabel.moduleRole,
        permissionId: permissionIdObj.moduleRole,
      },
      {
        key: "moduleRoleAdd",
        label: childrenLabel.moduleRoleAdd,
        permissionId: permissionIdObj.moduleRoleAdd,
      },
    ],
  },
  {
    key: "userManager",
    permissionId: permissionIdObj.userManager,
    icon: React.createElement(icons[2]),
    label: parentLabel.userManager,
    children: [
      {
        key: "userSearch",
        label: childrenLabel.userSearch,
        permissionId: permissionIdObj.userSearch,
      },
      {
        key: "userAdd",
        label: childrenLabel.userAdd,
        permissionId: permissionIdObj.userAdd,
      },
    ],
  },
  {
    key: "studentInfoManage",
    permissionId: permissionIdObj.studentInfo,
    icon: React.createElement(icons[3]),
    label: parentLabel.studentInfoManage,
    children: [
      {
        key: "studentInfoAdd",
        label: childrenLabel.studentInfoAdd,
        permissionId: permissionIdObj.studentInfoAdd,
      },
      {
        key: "studentInfoSearch",
        label: childrenLabel.studentInfoSearch,
        permissionId: permissionIdObj.studentInfoAdd,
      },
    ],
  },
];

/**
 * 获取权限路由
 * @param {*} permissionIdList
 * @returns
 */
export const getRouterConfig = (permissionIdList) => {
  if (
    !permissionIdList ||
    !Array.isArray(permissionIdList) ||
    permissionIdList.length < 1
  )
    return [];

  const res = [];
  for (let idx = 0; idx < routerConfig.length; idx++) {
    const item = routerConfig[idx];
    if (!permissionIdList.includes(item.permissionId)) continue;

    const copyItem = {};
    for (let key in item) {
      if (key !== "children") {
        copyItem[key] = item[key];
      }
    }
    const children = JSON.parse(JSON.stringify(item.children));
    copyItem.children = children;

    for (let j = 0; j < children.length; j++) {
      if (!permissionIdList.includes(children[j].permissionId)) {
        children.splice(j, 1);
        j--;
      }
    }

    res.push(copyItem);
  }

  return res;
};

export const mockData = {
  code: 0,
  info: "登录成功",
  data: {
    token_info: {
      user_id: 1,
      user_name: "admin",
      role_id: 1,
      permissions: [
        "1001",
        "1002",
        "1003",
        "1001001",
        "1001002",
        "1002001",
        "1002002",
        "1003001",
        "1003002",
      ],
    },
    token:
      "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxIiwiYXV0aG9yaXRpZXMiOnsidXNlcklkIjoxLCJ1c2VyTmFtZSI6ImFkbWluIiwicm9sZUlkIjoxLCJwZXJtaXNzaW9ucyI6WyIxMDAxMDAxIiwiMTAwMTAwMiIsIjEwMDIwMDEiLCIxMDAyMDAyIiwiMTAwMzAwMSIsIjEwMDMwMDIiXX0sImlhdCI6MTcyNTYxNDE3NywiZXhwIjoxNzI1NzAwNTc3fQ.e_jfureR5td6Gq1g1Mye2FtCPrgMjOnAdZUzkBYCG2UHyRbJJdtdWwLIYm1qh1xaybwFqarAQYjbcNH6mm_MLg",
  },
};
